'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PopoverMenuItem = require('components/PopoverMenu/PopoverMenuItem');

var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);

var _PopoverMenu = require('components/PopoverMenu/PopoverMenu');

var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumItemPopover = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(AlbumItemPopover, _PureComponent);

  function AlbumItemPopover() {
    (0, _classCallCheck3.default)(this, AlbumItemPopover);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumItemPopover.__proto__ || (0, _getPrototypeOf2.default)(AlbumItemPopover)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumItemPopover, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          onInit = _props.onInit,
          onDelete = _props.onDelete,
          onPlay = _props.onPlay,
          onDownloadPress = _props.onDownloadPress,
          hidePlay = _props.hidePlay,
          hidePress = _props.hidePress;
      var t = this.context.t;


      return _react2.default.createElement(
        _PopoverMenu2.default,
        { id: id, ref: onInit },
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onPlay, title: t('Play All'), iconClass: 'icon-play', hidden: hidePlay }),
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDownloadPress, title: t('Press'), iconClass: 'icon-download', hidden: hidePress }),
        _react2.default.createElement(_PopoverMenuItem2.default, { onClick: onDelete, title: t('Delete'), iconClass: 'icon-delete' })
      );
    }
  }]);
  return AlbumItemPopover;
}(_react.PureComponent), _class.propTypes = {
  hidePlay: _propTypes2.default.bool,
  hidePress: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  onDelete: _propTypes2.default.func,
  onDownloadPress: _propTypes2.default.func,
  onInit: _propTypes2.default.func,
  onPlay: _propTypes2.default.func
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _class.defaultProps = {
  onDelete: _noop3.default,
  onDownloadPress: _noop3.default,
  onInit: _noop3.default,
  onPlay: _noop3.default
}, _temp);
exports.default = AlbumItemPopover;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItemPopover/AlbumItemPopover.js
// module id = 1945
// module chunks = 1